import { SearchableSelectField } from '../../shared/field/searchable_select_field.js';
import { StaticSelectField } from '../../shared/field/static_select_field.js';
import type { FieldShellExtras } from '../../shared/field/field_shell.js';

/** A partir de quantos motivos o select fechado cede ao campo com busca: até
 *  aqui a lista cabe numa olhada; acima, rolar 50 linhas é pior que digitar. */
export const SEARCHABLE_MOTIVES_ABOVE = 8;

export interface MotiveFieldCopy {
  readonly label: string;
  /** Select fechado sem escolha. */
  readonly selectPlaceholder: string;
  /** Campo com busca (lista longa) sem escolha. */
  readonly searchPlaceholder: string;
  readonly searchEmpty: string;
}

export interface MotiveOption {
  readonly id: string;
  readonly name: string;
}

/**
 * O Motivo da viagem — select, NÃO chips: a lista real vem do provider e chega
 * às dezenas (codificada por centro de custo), e chips viram muro. Acima do
 * teto a lista fechada vira muro também: 50 itens crus abrindo para cima e
 * estourando o topo do modal (#3217 C7), então o campo ganha busca. Os rótulos
 * ("--", "123456") seguem sendo do cadastro; o que muda aqui é só chegar a eles.
 */
export function MotiveField({
  motives,
  value,
  onChange,
  copy,
  adornment,
  adornmentLabel,
  message,
  messageTone,
  required,
  disabled = false,
}: FieldShellExtras &
  Readonly<{
    motives: readonly MotiveOption[];
    value: string;
    onChange: (motiveId: string) => void;
    copy: MotiveFieldCopy;
    /** Trava o campo: a lista não abre e o motivo não muda. */
    disabled?: boolean;
  }>) {
  const options = motives.map((m) => ({ value: m.id, label: m.name }));
  if (options.length > SEARCHABLE_MOTIVES_ABOVE) {
    return (
      <SearchableSelectField
        label={copy.label}
        adornment={adornment}
        adornmentLabel={adornmentLabel}
        message={message}
        messageTone={messageTone}
        required={required}
        value={value}
        options={options}
        onChange={onChange}
        placeholder={copy.searchPlaceholder}
        emptyText={copy.searchEmpty}
        disabled={disabled}
      />
    );
  }
  return (
    <StaticSelectField
      label={copy.label}
      adornment={adornment}
      adornmentLabel={adornmentLabel}
      message={message}
      messageTone={messageTone}
      required={required}
      value={value}
      options={options}
      onChange={onChange}
      placeholder={copy.selectPlaceholder}
      disabled={disabled}
    />
  );
}
